import IDimensions from '../../../common/model/IDimensions';

function buildId(dimensions: IDimensions): string {
  return `${dimensions.country}_${dimensions.brand}_insurance_block_input`;
}

export const insuranceBlockInputStorage = {
  get: (dimensions: IDimensions) => {
    return JSON.parse(localStorage.getItem(buildId(dimensions)) ?? 'null');
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  save: (dimensions: IDimensions, data: any) => {
    localStorage.setItem(buildId(dimensions), JSON.stringify(data));
  },
  clear: (dimensions: IDimensions) => {
    localStorage.removeItem(buildId(dimensions));
  },
};
